/**
 * The § 5a odst. 5 line that has to accompany a review written by someone we gave the product
 * to for free: "Tato recenze byla zveřejněna osobou, které jsme výrobek poskytli bezplatně
 * k vyzkoušení."
 *
 * The flag behind it is `is_gifted_product` on the feedback resource, camel-cased to
 * `isGiftedProduct` by the interceptor in @/utils/https. Nothing computes it: no column links a
 * review to an order, so marketing - who sent the product - ticks it by hand in the admin panel,
 * and can untick it again at any time. A cached product page is the one place such an edit can
 * hang.
 *
 * It carries no meaning on a reply (`child.data[]`), which the shop writes rather than the
 * author of the review, so callers gate on the review being a top-level one.
 *
 * `giftedProductReviewNotice` comes from the translation sheet like every other caption. The key
 * bears no digit, so the interceptor leaves it alone - unlike `lowestPrice30DLabel`, which had to
 * be asked for under its camel-cased spelling.
 */
export default {
  name: 'GiftedReviewNotice',
  props: {
    gifted: {
      type: Boolean,
      default: false,
    },
  },
}
